import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { StaffDetailsTab } from '@features/staff-page/components/StaffDetailsTab'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/staff/$initials/')({
    component: RouteComponent,
})

function RouteComponent() {

    const { initials } = Route.useParams()

    return (
        <QueryErrorBoundary title='Failed to load staff details'>
            <Suspense fallback={<LoadingIndicator resource='staff details'/>}>
                <StaffDetailsTab initials={initials} />
            </Suspense>
        </QueryErrorBoundary>
    )
}
